import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { useTheme } from '@mui/material/styles';

import { useTranslation } from '../../context/TranslationContext';

import DialogBase from './DialogBase';

const ConfirmationDialog = ({
  title,
  subtitle,
  isOpen,
  onClose,
  onConfirm,
  inProgress = false,
  confirmLabel,
  confirmDisabled = false,
  confirmIcon = <CheckCircleIcon />,
  cancelLabel,
  cancelIcon,
  icon,
  warningMessage,
  hideCloseIcon = false,
}) => {
  const theme = useTheme();
  const { translate } = useTranslation();

  const defaultConfirmLabel = confirmLabel || translate('confirm');
  return (
    <DialogBase
      title={title}
      subtitle={subtitle}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={!confirmDisabled ? onConfirm : undefined}
      inProgress={inProgress}
      icon={icon || <QuestionMarkIcon style={{ fontSize: '74px', color: 'white' }} />}
      bgColor={theme.palette.primary.main}
      confirmLabel={defaultConfirmLabel}
      cancelLabel={cancelLabel}
      cancelIcon={cancelIcon}
      confirmButtonColor="primary"
      confirmDisabled={confirmDisabled}
      confirmIcon={confirmIcon}
      warningMessage={warningMessage}
      hideCloseIcon={hideCloseIcon}
    />
  );
};

export default ConfirmationDialog;
